import { render, staticRenderFns } from "./HGConclusion.vue?vue&type=template&id=740cd3e6&scoped=true&"
import script from "./HGConclusion.vue?vue&type=script&lang=js&"
export * from "./HGConclusion.vue?vue&type=script&lang=js&"
import style0 from "./HGConclusion.vue?vue&type=style&index=0&id=740cd3e6&lang=scss&scoped=true&"
import style1 from "./HGConclusion.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740cd3e6",
  null
  
)

export default component.exports